import { render, staticRenderFns } from "./ManagementAddContractorInfoEmail.vue?vue&type=template&id=1338d048&scoped=true"
import script from "./ManagementAddContractorInfoEmail.vue?vue&type=script&lang=ts"
export * from "./ManagementAddContractorInfoEmail.vue?vue&type=script&lang=ts"
import style0 from "./ManagementAddContractorInfoEmail.vue?vue&type=style&index=0&id=1338d048&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338d048",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1338d048')) {
      api.createRecord('1338d048', component.options)
    } else {
      api.reload('1338d048', component.options)
    }
    module.hot.accept("./ManagementAddContractorInfoEmail.vue?vue&type=template&id=1338d048&scoped=true", function () {
      api.rerender('1338d048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ManagementAddContractorInfoEmail.vue"
export default component.exports